import axiosInstance from '@/utils/https';
import axios from 'axios';

export type SupportProps = {
  name: string;
  emailAddress: string;
  description: string;
  category: string;
  outlet: string;
  phoneNumber: string;
  file: any;
};

const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
export const CreateSupport = async (payload: SupportProps) => {
  try {
    const url = `${baseURL}/api/v1/fans/create-task`;
    const formData = new FormData();

    formData.append('name', payload.name);
    formData.append('emailAddress', payload.emailAddress);
    formData.append('description', payload.description);
    formData.append('category', payload.category);
    formData.append('outlet', payload.outlet);
    formData.append('phoneNumber', payload.phoneNumber);
    if (payload.file) {
      formData.append('file', payload.file);
    }
    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllOutlets = async () => {
  try {
    const url = `api/v1/outlets`;
    const response = await axiosInstance.get(url);

    return response.data;
  } catch (error) {
    throw error;
  }
};
